/**
 * Workbench-wide responsive visibility policy for dockview areas.
 * This is presentation policy for the platform shell and is independent of
 * whichever module currently occupies the editor.
 */

export const AUXILIARY_BAR_AUTO_HIDE_BELOW_PX = 700;
export const AUXILIARY_BAR_AUTO_RESTORE_FROM_PX = 705;

export type AuxiliaryBarResponsiveAction = 'hide' | 'show' | 'none';

/**
 * Resolve the auxiliary-bar action with a 100px hysteresis band.
 *
 * `automaticallyHidden` is ownership, not current visibility: widening may
 * restore only a bar hidden by this policy, never one the user hid manually.
 */
export function resolveAuxiliaryBarResponsiveAction(
  width: number,
  automaticallyHidden: boolean,
): AuxiliaryBarResponsiveAction {
  if (width < AUXILIARY_BAR_AUTO_HIDE_BELOW_PX) {
    return 'hide';
  }
  if (width >= AUXILIARY_BAR_AUTO_RESTORE_FROM_PX && automaticallyHidden) {
    return 'show';
  }
  return 'none';
}
